import { Anchor, Box, Image } from 'grommet';
import React from 'react';

export const LiveVideo = () => {
  return (
    <Anchor target="_blank" href={"https://tsfkam.vestfoldit.no/latest.php?v=1"} >
      <Box height="medium">
        <Image src="https://tsfkam.vestfoldit.no/latest.php?v=1" fit="cover" alt="Siste bilde" />
      </Box >
    </Anchor >
  );
};


